<template>
  <div class="box2-container">
    <div class="title">
      <div class="left_title">视频监控</div>
      <div class="item_one">摄像头总数：<span>{{itemData.all_number}}</span></div>
      <div class="item_one">在线数：<span>{{itemData.online_number}}</span></div>
    </div>
    <div class="content">
      <div class="video" v-if="itemData.ysyNumber">
        <iframe
          :src="'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/'+itemData.ysyNumber+'/1.live&autoplay=1&accessToken='+accessToken"
          width="100%"
          height="100%"
          :id="'ysy'+itemData.ysyNumber"
          allowfullscreen
        >
        </iframe>
      </div>
      <div class="video" v-else><img src="@/assets/home_images/video.png" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box2', 
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          ysyNumber:'',
          all_number:0,
          online_number:0
        };
      },
    },
    accessToken: {
      type: String,
      required: true, // 默认值是false
      default: function () {
        return ''
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang='less'>
.box2-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    font-size: 14px;
    line-height: 30px;
    font-weight: normal;
    color: #fff;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    .item_one{
      margin-right:50px;
      align-items: center;
      justify-content: center;
      display: flex;
      color: rgba(255, 255, 255, 0.7);
      font-size: 13px;
      span{
        font-size: 24px;
        color: #77c6fe;
        font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      }
    }
    .left_title{
      font-size: 18px;
      line-height: 30px;
      font-weight: normal;
      color: #fff;
      margin-right: 60px;
    }
  }
  .content {
    position: absolute;
    padding-top: 40px;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    box-sizing: border-box;
    .video {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
      iframe{
        margin: 0;
        padding: 0;
        border:0;
      }
    }
  }
}
</style>
